var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corporateCultureBox"},[_c('aboutBannerVue',{attrs:{"tabIndex":"7"}}),_c('div',{class:_vm.isMobile?'mobileShow':'socialBox'},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"contents",class:_vm.isMobile?'socialMobile':'',domProps:{"innerHTML":_vm._s(_vm.info.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }